import { Typography } from '@mui/material';
import { PATHS } from '@client/routes';
import LinkedTabs from './components/LinkedTabs';
import { TitledPage } from '@client/new/components/Misc';
import { trackEvent } from '@services/tracking';

type CreatorCrmLayoutProps = {
  influencerId: number;
  children: React.ReactNode;
  actionBar?: React.ReactElement;
};
export const CreatorCrmLayout = ({
  influencerId,
  children,
  actionBar,
}: CreatorCrmLayoutProps) => {
  const pathname = window.location.pathname;

  const TABS = [
    {
      id: 0,
      label: 'Users',
      link: PATHS.CRM_CREATOR(influencerId, 'users'),
    },
    {
      id: 1,
      label: 'Webhooks',
      link: PATHS.CRM_CREATOR(influencerId, 'webhooks'),
      // onClick: () => {
      //   mixTrack({
      //     type: 'Tapped Webhooks',
      //     payload: {},
      //   });
      // },
    },
  ];

  const activeTab = pathname.includes(
    PATHS.CRM_CREATOR(influencerId, 'webhooks'),
  )
    ? TABS[1].id
    : TABS[0].id;

  return (
    <TitledPage
      title="Marketing CRM"
      rightContent={actionBar}
      className="max-w-[2100px]"
    >
      <LinkedTabs tabs={TABS} activeTab={activeTab}>
        <div className="py-5">{children}</div>
      </LinkedTabs>
    </TitledPage>
  );
};
